import { Avatar } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';
import Ceren from 'assets/images/auth/ceren.png';
import { AuthButtonComponent } from '../../components/auth-button/auth-button.component';

const DIV = styled.div`
  min-height: calc(100vh - 140px);
  display: flex;
  align-items: center;
  margin-top: -40px;
`;

interface IGreetingProps {
  onNext: () => void;
}
export const Greeting: FC<IGreetingProps> = ({ onNext }) => (
  <DIV>
    <div className="fadein animation-duration-500 flex flex-column md:flex-row">
      <div style={{ width: 184 }} className="m-auto md:m-0 md:mr-7">
        <Avatar size={184} className="mt-5 mb-4" src={Ceren} />
      </div>
      <div className="font-medium text-center md:text-left">
        <div className="text-3xl font-bold mb-4 c-dark-blue">Hi 👋, Welcome to 32Co</div>
        <div className="text-base font-semibold mb-5" style={{ color: '#2d2d2d' }}>
          I’m Dr. Ceren, one of the many dentists that work for 32Co. It’s time to get you providing Clear Aligners
          differently.
        </div>
        <p className="text-sm mb-4" style={{ color: '#333' }}>
          Get started by telling us a little bit about yourself to gain instant access to the platform and our
          educational content. Don’t worry it only takes 2 minutes
        </p>
        <p className="text-sm mb-4" style={{ color: '#333' }}>
          If you get stuck along the way contact us at{' '}
          <a href="mailto:support@32co.com">
            <b className="c-black">support@32co.com</b>
          </a>
          , we’re always here to help.
        </p>
        <div className="flex justify-content-center md:justify-content-start">
          <AuthButtonComponent onClick={onNext}>Get Started</AuthButtonComponent>
        </div>
      </div>
    </div>
  </DIV>
);
